/**
 * web-account-pages D1 — Bookings (`/account/bookings`); signed out, the sign-in step in place. Below 768px the app's
 * Bookings (D8). web-studio-sites D12: on a custom site, Waiting on you and the next session sit at the top, above the
 * bookings (Gabriel 2026-10-25: "putting the waiting on you. And next session at the top of her bookings page.").
 */
import { PhoneBookings } from '../../phone/PhoneBookings';
import { BookingsList } from '../../pieces/bookings-list';
import { NextSession } from '../../pieces/next-session';
import { WaitingOnYou } from '../../pieces/waiting-on-you';
import { readSite } from '../../site';
import { useAppScreens } from '../../ui/useIsPhone';
import { usePageTitle } from '../../ui/usePageTitle';
import { SignedInOnly } from './SignedInOnly';

const NEXT_SESSION = { heading: 'Your next session' };

function CustomSiteTop() {
  return (
    <>
      <WaitingOnYou />
      <NextSession options={NEXT_SESSION} />
    </>
  );
}

export function BookingsPage() {
  usePageTitle('Bookings');
  const phone = useAppScreens();
  return (
    <SignedInOnly>
      {phone ? <PhoneBookings /> : readSite() ? <BookingsList top={<CustomSiteTop />} nextOnTop /> : <BookingsList />}
    </SignedInOnly>
  );
}
